<script>

import refFichaEmergencia from '@src/components/rel-ficha-emergencia.vue'

/**
 * Viewer Receituário
 */
export default {
  components: {
    refFichaEmergencia
  },
  props: {
    id: "",
    ficha: {},
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    printFichaEmergencia() {
      this.$root.$emit('print-ficha-emergencia')
    },
  },
}
</script>
<template>
  <div>
    <b-modal :id="id" size="lg" :hide-footer="true">
      <refFichaEmergencia :ficha="ficha" />
      <template v-slot:modal-header>
        <div class="ml-auto">
          <b-button
            class="mr-2"
            variant="danger"
            @click="$bvModal.hide(id)"
            >Sair</b-button
          >         
          <b-button variant="primary" @click="printFichaEmergencia()"
            >Imprimir</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>
<style>
</style>